import { FrontNotification } from '@/data'
import { StoreActionMap } from '@/store/types'
import update from 'immutability-helper'

export interface NotificationsReducer {
  currentNotifications: FrontNotification[]
}

export const initialNotificationsReducerState: NotificationsReducer = {
  currentNotifications: [],
}

export enum NotificationsTypes {
  Restore = 'Notifications/RESTORE',
  Add = 'Notifications/ADD',
  Remove = 'Notifications/REMOVE',
  Cleanup = 'Notifications/CLEAN',
}

type NotificationsPayload = {
  [NotificationsTypes.Restore]: NotificationsReducer
  [NotificationsTypes.Add]: FrontNotification
  [NotificationsTypes.Remove]: string | null
  [NotificationsTypes.Cleanup]: null
}

export type NotificationsActions = StoreActionMap<NotificationsPayload>[keyof StoreActionMap<NotificationsPayload>]

const notificationsReducer = (curState: NotificationsReducer, action: NotificationsActions): NotificationsReducer => {
  let newState: NotificationsReducer
  switch (action.type) {
    case NotificationsTypes.Restore:
      return {
        ...action.payload,
      }
    case NotificationsTypes.Add: {
      newState = update(curState, {
        currentNotifications: { $push: [action.payload] },
      })
      break
    }
    case NotificationsTypes.Remove: {
      const index = curState.currentNotifications.findIndex((it) => it.id === action.payload)
      newState = update(curState, {
        currentNotifications: { $splice: [[index, 1]] },
      })
      break
    }
    case NotificationsTypes.Cleanup:
      return initialNotificationsReducerState
    default:
      newState = curState
  }
  return newState
}

export default notificationsReducer
